"use client";

// hooks/useWindowSize.ts
import { useState, useEffect } from "react";

const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
};

export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 0,
    isSm: false,
    isMd: false,
    isLg: false,
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      const width = window.innerWidth;
      setWindowSize({
        width,
        isSm: width <= BREAKPOINTS.sm,
        isMd: width <= BREAKPOINTS.md,
        isLg: width <= BREAKPOINTS.lg,
      });
    };

    // Run once on mount to set initial values
    handleResize();

    // Listen to resize events
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
}
